var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.867,
    height: 209.947,
    viewBox: "0 0 197.867 209.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_238787752",
    d: "M36.788,18.075a99.147,99.147,0,0,1,118,4.581,89.033,89.033,0,0,0-29.391-10.35C106.147,9.441,86.225,13.4,69,22.249,50.431,31.8,34.441,46.793,24.83,65.413c-7,13.566-9.52,26.107-7.67,41C2.362,97.7-.525,77.589.732,64.239c6.311-15.761,18.93-34.413,36.056-46.164Z",
    transform: "translate(6.175 -0.808)",
    fill: "#fffbf5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_238787392",
    d: "M176.523,1.064c2.371,30.645-18.01,69.447-42.383,90.942a40.264,40.264,0,0,0-2.908-15.776C115.153,87.511,95.7,98.656,76.058,102.91c-16.914,3.664-36.91,3.159-52.307-5.456a42.284,42.284,0,0,1-18.88-19.14c-6.78-13.737-5.09-31.188.253-45.231-.786,15.707,3.823,32.07,18.854,39.942C44.583,83.817,69.069,81.276,89,70.2c9.189-5.107,17.965-10.728,25.208-18.3-2.66-5.768-16.061-15.388-21.573-18.957,30.278-1.743,59.606-14.669,83.885-31.873Z",
    transform: "translate(-0.423 36.056)",
    fill: "#fffbf5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_238787488",
    d: "M183.486,1.207c8.246,18.74,11.074,39.66,7.285,59.691a96.5,96.5,0,0,1-16.962,39.347c-4.749,6.8-11.8,13.632-17.794,19.294,1.956-11.081,4.253-23.773,1.576-33.038-24.266,15.963-46.123,26.3-75.631,29.6-16.186,1.807-33.277,1.239-48.425-5.556C19,104.025,4.791,91.364.463,75.63c10.148,14.446,17.77,21.158,36.78,25.923a94.19,94.19,0,0,0,33.646,2.121,141.1,141.1,0,0,0,75.062-32.606c24.712-21.134,33.73-42.371,37.534-69.86Z",
    transform: "translate(5.439 56.614)",
    fill: "#fffbf5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_238787080",
    d: "M118.913,1.924c-.441,4.362-2.073,8.483-3.762,12.491A75.242,75.242,0,0,1,92.436,43.68a50.9,50.9,0,0,1-10.49,6.656c1.2-4.813,2.485-10.19,2.234-13.865a127.633,127.633,0,0,1-26.457,1.614C38.838,36.913,16.205,28.754.67,15.726c20.1,8.566,43.868,9.169,64.746,5.853a147.375,147.375,0,0,0,53.5-19.654Z",
    transform: "translate(35.193 159.611)",
    fill: "#fffbf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.3de103da3903ed1d90ebf8c434f7985b.svg";
export { ForwardRef as ReactComponent };